import { render, staticRenderFns } from "./CostMover.vue?vue&type=template&id=4f4ddf24&scoped=true&"
import script from "./CostMover.vue?vue&type=script&lang=js&"
export * from "./CostMover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4ddf24",
  null
  
)

export default component.exports